<template>
  <a-layout style="height: 100vh">
    <a-layout-header class="header">
      <div class="logo" style="display: inline-block;height: 100%">
        <img src="../../assets/cibrlogo.png" style="height: 80%;margin-right: 20px">
      </div>
      <a-menu
          v-model:selectedKeys="menu"
          theme="dark"
          mode="horizontal"
          :style="{ lineHeight: '64px' }"
          style="display: inline-block"
      >
        <a-menu-item key="home" @click="goto('/home')">{{ $t("home") }}</a-menu-item>
        <a-menu-item key="history"  @click="goto('/history')">{{ $t("history") }}</a-menu-item>
      </a-menu>
      <div class="personal-div">
        <a-button @click="changeLang('zh')" v-if="locale === 'en'">中文</a-button>
        <a-button @click="changeLang('en')"  v-if="locale === 'zh'">English</a-button>
        <a-dropdown>
          <template #overlay>
            <a-menu>
              <a-menu-item key="2" v-if="isAdmin" @click="gotoAdmin">
                <SettingOutlined />
                {{ $t("system") }}
              </a-menu-item>
              <a-menu-item key="exit" @click="exitSystem">
                <LogoutOutlined />
                {{ $t("exit") }}
              </a-menu-item>
            </a-menu>
          </template>
          <a-button style="margin-left: 10px">
            <UserOutlined />
            {{ userName }}
            <DownOutlined />
          </a-button>
        </a-dropdown>
      </div>
    </a-layout-header>
    <a-layout>
      <a-layout style="padding: 8px 8px">
        <a-layout-content
            :style="{ background: '#fff', padding: '8px', margin: 0, minHeight: '280px',overflow: 'auto' }"
        >
          <slot name="mainContent"></slot>
          <div style="height: 100px"></div>
          <a-layout-footer :style="{padding: '0 0', textAlign: 'center',background: 'white', color : 'darkgrey'}">Copy right ©2018北京脑科学与类脑研究中心遗传操作中心&网络与信息化办公室 版权所有 ICP备案号 <a target="_blank" rel="noopener" href="http://beian.miit.gov.cn/" class="copy">京ICP备 18029179号</a></a-layout-footer>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/12 14:25
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import { DownOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons-vue';

export default {
  name: "geneticNav",
  components: {VLoading, DownOutlined, LogoutOutlined, SettingOutlined, UserOutlined},
  props:{
    current : String
  },
  data() {
    return {
      loading: false,
      locale : localStorage.getItem('local')||'zh',
      menu : [this.current],
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      // var post = {}
      // util.$post("", post, (res) => {
      //   console.log(res);
      // }, this.showMask, this.hideMask);
    },
    goHome(){
      this.$router.push("/home")
    },
    goto(route){
      this.$router.push(route);
    },
    exitSystem(){
      this.loading = true;
      window.open(util.casOutUrl);
      setTimeout(function () {
        window.location.reload();
      }, 5000);
    },
    gotoAdmin(){
      this.$router.push("/geneticAdmin")
    },
    changeLang : function (flag){
      localStorage.setItem('local', flag);
      window.location.reload();
    },
  },
  computed : {
    userName : function (){
      if (this.locale === "zh"){
        return this.$store.getters.getUser.name;
      }
      return this.$store.getters.getUser.englishname;
    },
    isAdmin : function (){
      return this.$store.getters.isGeneticAdmin
    },
    noticeShow (){
      return this.$store.getters.getNotice;
    }
  }
}
</script>

<style scoped>
.personal-div{
  float: right;
  display: inline-block;
}
</style>